import React from "react";
import DOMPurify from 'dompurify';
import { isBrowser } from "react-device-detect";
import { Box, Typography, Button } from "@mui/material";
import Popup from "./Popup.js";

const NotificationPopup = ({ open, onClose, onProceed, title, message, iconSrc, buttonLabel, proceedButtonLabel, variant }) => (
  <Popup
    open={open}
    setOpen={onClose}
    onClose={onClose}
    popupStyle={{
      minWidth: isBrowser ? 400 : 200,
    }}
    title={title}
    variant={variant}
  >
    <Box sx={{ py: 2, px: 4, textAlign: "center" }}>
      {iconSrc && <img src={iconSrc} alt="comment" style={{ height: "60px" }} />}
      {typeof message === 'string' ?
        <Typography
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(message, {
              FORBID_TAGS: [
                'script', 'iframe', 'svg', 'form', 'img', 'table', 'object', 'embed', 'link', 'style'
              ],
              FORBID_ATTR: [
                'onclick', 'onload', 'onerror', 'onmouseover', 'onfocus', 'onmouseenter', 'onmouseleave',
                'onmousedown', 'onmouseup', 'onkeydown', 'onkeyup', 'onkeypress', 'oninput', 'onchange',
                'onblur', 'onreset', 'onsubmit', 'onselect', 'onunload', 'onwheel', 'onauxclick',
                'onpointerdown', 'onpointermove', 'onpointerup', 'onpointercancel', 'onpointerover',
                'onpointerout', 'onpointerenter', 'onpointerleave', 'ongotpointercapture', 'onlostpointercapture',
                'ontouchstart', 'ontouchmove', 'ontouchend', 'ontouchcancel', 'onanimationstart', 'onanimationend',
                'onanimationiteration', 'ontransitionend', 'ontransitionstart', 'ontransitionrun', 'ontransitioncancel',
                'onbeforeinput', 'oncompositionstart', 'oncompositionupdate', 'oncompositionend', 'onselectstart',
                'onselectionchange', 'onfullscreenchange', 'onfullscreenerror', 'onpointerlockchange', 'onpointerlockerror',
                'oncut', 'oncopy', 'onpaste', 'href', 'src'
              ]
            })
          }}
        />
        : message
      }
      {onProceed && (
        <Button variant="contained" color={variant} onClick={onProceed} sx={{ borderRadius: "10px", lineHeight: "normal", mt: 2, mb: 1, mr: buttonLabel ? 3 : 0 }}>
          {proceedButtonLabel}
        </Button>
      )}
      {buttonLabel && (
        <Button variant="outlined" color="inherit" onClick={onClose} sx={{ borderRadius: "10px", lineHeight: "normal", mt: 2, mb: 1 }}>
          {buttonLabel}
        </Button>
      )}
    </Box>
  </Popup>
);

export default NotificationPopup;
